import { Dialog, DialogType } from '../../../../src/feature/narrator/narrator.model';

export const dialog: Dialog[] = [
  {
    id: 'start',
    type: DialogType.description,
    text: 'Niklas stands in the doorway of a low house, wiping his hands on a cloth. He nods as you come near.',
    options: [
      { text: 'Greet him.', nextDialogId: 'greet' },
      { text: 'Ask how he fares.', nextDialogId: 'fare' },
    ],
  },
  {
    id: 'greet',
    type: DialogType.dialog,
    text: 'Good day, traveller. Not many faces pass this way now.',
    options: [
      { text: 'Why so few?', nextDialogId: 'plague' },
      { text: 'Just passing through.', nextDialogId: 'bye' },
    ],
  },
  {
    id: 'fare',
    type: DialogType.dialog,
    text: 'Well enough. Better than some. The house beside mine has stood shut since autumn.',
    options: [
      { text: 'Shut? Why?', nextDialogId: 'plague' },
      { text: 'I am glad you are well.', nextDialogId: 'bye' },
    ],
  },
  {
    id: 'plague',
    type: DialogType.dialog,
    text: 'The sickness came through the village. It took my brother and his wife both. We do not speak of it much.',
    options: [{ text: 'I am sorry.', nextDialogId: 'bye' }],
  },
  {
    id: 'bye',
    type: DialogType.dialog,
    text: 'Safe travels, friend. Mind the road.',
    options: [{ text: 'Leave.', nextDialogId: 'start' }],
  },
];
